import * as geoContentService from '@/services/geoContentService'
const initialState = {
    geoContent: null,
    geoContents: null,
    status: null,
    licenses: null,
    licenseConsumption: null,
    licenseConsumptionLoading: false,
    products: null
}

export const geoContent = {
    namespaced: true,
    state: initialState,
    actions: {
        getGeoContents({ dispatch, commit }, id) {
            commit('geoContentsRequest');
            geoContentService.getGeoContents()
                .then(resp => {
                    var geoContents = resp.data;
                    if (geoContents) {
                        commit('geoContentsSuccess', geoContents);
                    }
                    else {
                        commit('geoContentsFailure', 'error.message');
                    }
                })
                .catch(error => {
                    commit('geoContentsFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                });
        },
        getGeoContent({ dispatch, commit }, id) {
            if (!id) {
                return Promise.resolve();
            }
            commit('geoContentRequest');
            return geoContentService.getGeoContent(id)
                .then(resp => {
                    var geoContent = resp.data;

                    if (geoContent) {
                        commit('geoContentSuccess', geoContent);
                    }
                    else {
                        commit('geoContentFailure', 'error.message');
                    }
                })
                .catch(error => {
                    commit('geoContentFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                });
        },
        getLicenses({ dispatch, commit }, gcid) {
            if (!gcid) {
                return Promise.resolve();
            }
            commit('gcLicenses', null);
            commit('gcLicenseConsumption', null);
            const licensesPromise = geoContentService.getLicenses(gcid)
                .then(resp => {
                    commit('gcLicenses', resp.data)
                })
                .catch(error => {
                    commit('gcLicenses', null);
                    dispatch('alert/error', error.message, { root: true });
                });
            dispatch('getLicenseConsumption', gcid);
            return licensesPromise;
        },
        getLicenseConsumption({ dispatch, commit }, gcid) {
            if (!gcid) {
                return Promise.resolve();
            }
            commit('gcLicenseConsumptionLoading', true);
            commit('gcLicenseConsumption', null);
            return geoContentService.getLicenseConsumption(gcid)
                .then(resp => {
                    const map = {};
                    (resp.data || []).forEach(row => {
                        map[row.licenseId] = row.consumed;
                    });
                    commit('gcLicenseConsumption', map);
                })
                .catch(error => {
                    commit('gcLicenseConsumption', null);
                    dispatch('alert/error', error.message, { root: true });
                })
                .finally(() => {
                    commit('gcLicenseConsumptionLoading', false);
                });
        },
        addLicense({ dispatch, commit }, { email, gcid, prodid, exp, devnum }) {
            commit('geoContentRequest');
            return geoContentService.addLicense(email, prodid, exp, devnum)
                .then(() => Promise.all([
                    dispatch('getGeoContent', gcid),
                    dispatch('getLicenses', gcid)
                ]))
                .catch(error => {
                    commit('geoContentFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                    return Promise.reject(error);
                });
        },
        removePermit({ dispatch, commit }, { userid, gcid, prodid }) {
            commit('geoContentRequest');
            return geoContentService.removePermit(userid, prodid)
                .then(() => Promise.all([
                    dispatch('getGeoContent', gcid),
                    dispatch('getLicenses', gcid)
                ]))
                .catch(error => {
                    commit('geoContentFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                    return Promise.reject(error);
                });
        },
        addUpdateProduct({ dispatch, commit }, prod) {
            commit('geoContentRequest');
            geoContentService.addUpdateProduct(prod)
                .then(resp => {
                    dispatch('getGeoContent', prod.gcid);
                })
                .catch(error => {
                    commit('geoContentFailure', error.message);
                    dispatch('alert/error', error.message, { root: true });
                });
        }
    },
    mutations: {
        geoContentRequest(state) {
            state.status = { loading: true };
        },
        geoContentSuccess(state, geoContent) {
            state.status = { loaded: true };
            state.geoContent = geoContent;
        },
        geoContentFailure(state) {
            state.status = null;
        },

        geoContentsRequest(state) {
            state.status = { loading: true };
            state.geoContents = null;
        },
        geoContentsSuccess(state, geoContents) {
            state.status = { loaded: true };
            state.geoContents = geoContents;
        },
        geoContentsFailure(state) {
            state.status = null;
            state.geoContents = null;
        },
        gcLicenses(state, licenses) {
            state.licenses = licenses;
        },
        gcLicenseConsumption(state, consumption) {
            state.licenseConsumption = consumption;
        },
        gcLicenseConsumptionLoading(state, loading) {
            state.licenseConsumptionLoading = loading;
        },
        processing(state, boolVal) {
            state.status = { processing: boolVal };
        },
        uploading(state, boolVal) {
            state.status = { uploading: boolVal };
        }
    },
    getters: {
        gcid: state => {
            if (state.geoContent) {
                return state.geoContent.id;
            }
            return null;
        }
    }
}